var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFabHeadset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.14,
    height: 23.407,
    viewBox: "0 0 26.14 23.407",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-headset",
    "data-name": "Icon awesome-headset",
    d: "M9.8,9.509A1.556,1.556,0,0,0,8.169,8.046H7.352a3.111,3.111,0,0,0-3.267,2.926v2.194a3.111,3.111,0,0,0,3.267,2.926h.817A1.556,1.556,0,0,0,9.8,14.629Zm8.986,6.583a3.111,3.111,0,0,0,3.267-2.926V10.972a3.111,3.111,0,0,0-3.267-2.926h-.817a1.556,1.556,0,0,0-1.634,1.463v5.12a1.556,1.556,0,0,0,1.634,1.463ZM13.07,0C5.778,0,.234,5.432,0,11.7v.731a.777.777,0,0,0,.817.731h.817a.777.777,0,0,0,.817-.731V11.7c0-5.243,4.764-9.509,10.619-9.509S23.689,6.46,23.689,11.7h-.006c0,.111.006,7.576.006,7.576a2.055,2.055,0,0,1-2.159,1.933H16.337a2.333,2.333,0,0,0-2.451-2.194H12.253A2.333,2.333,0,0,0,9.8,21.212a2.333,2.333,0,0,0,2.451,2.194h9.278A4.388,4.388,0,0,0,26.14,19.28V11.7C25.906,5.432,20.362,0,13.07,0Z",
    fill: "#eb5a78"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFabHeadset);
export default __webpack_public_path__ + "static/media/fab-headset.83e30d9f8eb35012e9d2b6dc6a70ccc6.svg";
export { ForwardRef as ReactComponent };